import { Persona_Inquiry_Status_Enum } from 'graphql/generated/hasura';

export const ERROR_STATUSES = [
  Persona_Inquiry_Status_Enum.Declined,
  Persona_Inquiry_Status_Enum.Expired,
] as Persona_Inquiry_Status_Enum[];
export const PENDING_STATUSES = [
  Persona_Inquiry_Status_Enum.MarkedForReview,
] as Persona_Inquiry_Status_Enum[];
